export default {
  title: 'Grenzgänger-Bewertung',
  noLongerRequired:
    'Für Grenzgänger-Bewertungen ist keine Vorabgenehmigung mehr erforderlich.',
  noLongerRequiredDescription:
    'Die Bewertung wird jetzt von Vamoz geprüft und von HR freigegeben. Sie müssen nichts weiter tun und können dieses Fenster schließen.'
};
